<template>
  <div>
    <div class="other-banner">
      <div class="w-default center">
        <ul class="crumb">
          <li>首页</li>
          <li>智慧物联解决方案</li>
        </ul>
        <h1>智慧物联解决方案</h1>
      </div>
    </div>
    <div class="introduction-row">
      <div class="w-default d-flex flex-colum ai-center">
        <h2>智慧物联解决方案</h2>
        <p>SC-AOP是深圳安信软件自主研发的一款面向未来的一体化运维管理平台级产品。该平台致力于为企业一站式解决IT运维管理问题，实现监控一体化、保障智能化、运维自动化。</p>
        <!-- <button></button> -->
      </div>
    </div>
    <div class="article-row w-default" id="article">
      <article v-show="isActive2=='1-1'">
        <h1 class="mb-30">应用场景</h1>
        <h3>1）安防运维系统</h3>
        <p class="mb-20">结合大数据、视频分析技术，智能发现安防系统存在的问题，并进行智能分析，实时告警，自动调整。例如当视频没有正常录制、录制不清晰时，智能定位问题，向管理人员进行告警，如果没有相关设置，系统自动根据配置进行自动调整。</p>
        <img class="mb-40 m-auto" src="../assets/img/SolutionInstrumentatio/eg1.png" alt="">
        <h3 class="mb-20">2）IT综合监控运维管理系统</h3>
        <img class="mb-20 m-auto" src="../assets/img/SolutionInstrumentatio/eg2.png" alt="">
        <p>
          ① 依托大数据平台、分布式计算机等技术，实现跨厂商、夸平台所有设备一体化监控、运维。
          <br />② 依托数据科学、人工智能等技术实现故障定位、趋势分析、提前预测故障、故障告警。
          <br />③ 自动化巡检、自动化运维。
        </p>
        <h3>3）应用性能分析</h3>
        <h3>4）业务系统巡检</h3>
        <h3>5）IT资产管理</h3>
        <h3 class="mb-60">6）IT运维服务</h3>

        <h1 class="mb-30">产品特色</h1>
        <h3>1）监控一体化</h3>
        <img class="m-auto" src="../assets/img/SolutionInstrumentatio/eg3.png" alt="">
        <h3>2）保障智能化</h3>
        <img class="m-auto" src="../assets/img/SolutionInstrumentatio/eg4.png" alt="">
        <h3>3）运维自动化</h3>
        <img class="m-auto" src="../assets/img/SolutionInstrumentatio/eg5.png" alt="">
        <h3>4）准确的故障定位</h3>
        <P>引擎接受原始警告，并根据预先制定的业务规则做出正确事件决策，实现告警事件的过滤、合并、分流、定位、告警等功能，同时可关联知识库专家系统快速形成对问题的解决方案。</P>
        <h3>5）灵活的告警侧率</h3>
        <p>通过短信、电话、微信、邮件、声光、弹窗等途径告知用户。</p>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive1: 1,
      isActive2: "1-1"
    };
  },
  methods: {
    show(event) {
      let el = event.currentTarget.parentNode;
      console.log(el);
      let flag = (" " + el.className + " ").indexOf(" " + "show" + " ") > -1;
      if (flag) {
        el.classList.remove("show");
      } else {
        el.classList.add("show");
      }
    },
    active(page) {
      this.isActive1 = page.split("-")[0];
      this.isActive2 = page;
      document.getElementById("article").scrollIntoView();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.other-banner {
  background: url("@/../../assets/img/banner/banner-index-2.jpg");
}
article {
  * {
    font-size: 16px;
  }
  flex: 1;
  .m-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mb-30 {
    margin-bottom: 30px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mb-60 {
    margin-bottom: 60px;
  }
  img {
    display: block;
    max-width: 100%;
  }
  h1 {
    font-size: 24px;
    border-left: 4px solid map-get($colors, "primary");
    padding-left: 14px;
    font-weight: bold;
  }
  h2 {
    line-height: 2;
  }
  h3 {
    line-height: 2;
  }
  p {
    line-height: 2;
  }
}
</style>
